module.exports = __webpack_public_path__ + "img/footer.4ea0daae.png";